import React, { useMemo } from "react";
import Select from "react-select";

function ReactSingleSelect({
                               options,
                               placeholder = "Select...",
                               onChange,
                               value = [],
                               disabled = false,
                               errors,
                               name
}) {

    const handleChange = (option) => {
        if (onChange) {
            onChange(option);
        }
    };

    const formattedOptions = useMemo(() => {
        return options.map((item) => ({
            label: item.Label || item.Name || item.Text || "N/A",
            value: item.Value || item.Id,
        }));
    }, [options]);

    return (
        <div className="react-select-container">
            <Select
                value={value}
                onChange={handleChange}
                options={formattedOptions}
                placeholder={placeholder}
                classNamePrefix="react-select"
                isDisabled = {disabled}
            />
            {errors && errors[name] && (
                <span className="fs-9 fw-bold text-danger">{errors[name].message}</span>
            )}
        </div>
    );
}

export default ReactSingleSelect;
